import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { useBoardStore } from './common/stores/useBoardStore';
import { AuthCallback } from './pages/GoogleAuthCallback';

import LoadingOverlay from '@/common/components/LoadingOverlay';
import { useAuthStore } from '@/common/stores/useAuthStore';
import { useSubscriptionStore } from '@/common/stores/useSubscriptionStore';
import Dashboard from '@/pages/Dashboard';
import Home from '@/pages/Home';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import { SpotifyCallback } from '@/pages/SpotifyCallback';
import TermsOfUse from '@/pages/TermsOfUse';

// Protected Route Component
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, loading: authLoading } = useAuthStore();

  if (authLoading) return <LoadingOverlay />;
  if (!user) return <Navigate to="/" replace />;

  return <>{children}</>;
};

const App = () => {
  const { checkAuthState, user } = useAuthStore();
  const { fetchBoards, loading: boardsLoading } = useBoardStore();
  const { fetchSubscription, fetchPrices } = useSubscriptionStore();

  useEffect(() => {
    const intialSetup = async () => {
      await checkAuthState();
      await fetchBoards();
    };

    intialSetup();
    fetchPrices();
  }, []);

  useEffect(() => {
    if (user) {
      fetchSubscription();
    }
  }, [user]);

  if (boardsLoading) return <LoadingOverlay />;

  return (
    <Routes>
      {/* Public Routes */}
      <Route element={<Home />} path="/" />
      <Route element={<PrivacyPolicy />} path="/privacy" />
      <Route element={<TermsOfUse />} path="/terms" />
      <Route element={<SpotifyCallback />} path="/callback/spotify" />
      <Route element={<AuthCallback />} path="/google/auth/callback" />

      {/* Protected Routes */}
      <Route
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
        path="/dashboard"
      />
    </Routes>
  );
};

export default App;
